/* ============================================================
   MARVIQ — assets/marviq-wishlist.js

   Wishlist is UI/UX only — unlike the cart, it isn't transactional or
   financial, so a lightweight local store is a reasonable default.
   This file is written as a small adapter so a real wishlist app
   (e.g. Swym, Wishlist King, Wishlist Hero — all available on the
   Shopify App Store) can be swapped in later WITHOUT touching any
   other file in the theme:

     1. Install the wishlist app.
     2. Replace the body of MarviqWishlist.has/toggle/list below with
        calls into that app's JS SDK (every major wishlist app exposes
        one — see the app's docs for its global object).
     3. Everything that calls window.MarviqWishlist (product cards,
        the product page, the header wishlist icon) keeps working
        unchanged, because the adapter's public method names don't
        change.

   If no app is installed, this degrades gracefully to a per-browser
   localStorage list — it never throws, and never blocks Add to Cart
   or checkout.
   ============================================================ */
(function () {
  "use strict";

  var STORAGE_KEY = "marviq_wishlist_v1";

  function safeRead() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : {};
    } catch (e) {
      return {};
    }
  }
  function safeWrite(data) {
    try { window.localStorage.setItem(STORAGE_KEY, JSON.stringify(data)); } catch (e) { /* storage unavailable — no-op */ }
  }

  var store = safeRead();

  function count() { return Object.keys(store).length; }
  function updateBadge() {
    var el = document.getElementById("wishCount");
    if (el) el.textContent = count();
  }

  var MarviqWishlist = {
    has: function (id) { return !!store[id]; },
    list: function () { return Object.values(store); },
    add: function (id, handle, title, image) {
      store[id] = { id: id, handle: handle, title: title, image: image, added_at: Date.now() };
      safeWrite(store);
      updateBadge();
    },
    remove: function (id) {
      delete store[id];
      safeWrite(store);
      updateBadge();
    },
    toggle: function (id, handle, title, image) {
      if (store[id]) { this.remove(id); return false; }
      this.add(id, handle, title, image);
      return true;
    }
  };

  window.MarviqWishlist = MarviqWishlist;

  document.addEventListener("DOMContentLoaded", updateBadge);
  updateBadge();

  /* Product card / quick view wishlist buttons (event delegation) */
  document.addEventListener("click", function (e) {
    var btn = e.target.closest("[data-wish-id]");
    if (!btn || btn.id === "wishBtn") return; // #wishBtn handled by product.js (needs full product context)
    e.preventDefault();
    var added = MarviqWishlist.toggle(btn.dataset.wishId, btn.dataset.wishHandle, "", "");
    btn.classList.toggle("active", added);
    btn.style.transform = "scale(1.25)";
    setTimeout(function () { btn.style.transform = ""; }, 220);
  });
})();
